var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "JUNE_ICONS",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m58.66,0c-6.98,0-12.66,5.68-12.66,12.66v9.34H11.78c-.63,0-1.15.51-1.15,1.15v47.7c0,.64.52,1.15,1.15,1.15h47.7c.63,0,1.15-.51,1.15-1.15V23.15c0-.64-.52-1.15-1.15-1.15h-11.18v-9.34c0-5.71,4.65-10.36,10.36-10.36s10.36,4.65,10.36,10.36v2.63h2.3v-2.63c0-6.98-5.68-12.66-12.67-12.66Zm-.33,69.7H12.93v-22.17c3.64-2.28,7.59-3.98,11.7-5.07-.02.29-.04.59-.04.89,0,6.08,4.95,11.03,11.03,11.03s11.03-4.95,11.03-11.03c0-.3-.01-.59-.04-.89,4.12,1.09,8.06,2.79,11.7,5.07v22.17Zm-31.43-26.35c0-.49.05-.98.13-1.46,2.81-.57,5.69-.88,8.6-.88s5.79.31,8.6.88c.08.48.13.97.13,1.46,0,4.81-3.92,8.73-8.73,8.73s-8.73-3.92-8.73-8.73Zm31.43-19.04v20.53c-6.87-4.01-14.68-6.12-22.7-6.12s-15.82,2.11-22.7,6.12v-20.53h45.4Zm-22.7,23.07c1.1,0,2-.9,2-2s-.9-2-2-2-2,.9-2,2,.9,2,2,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.4fba482722a9398cbd00d3b37ee77579.svg";
export { ForwardRef as ReactComponent };